import { withInstall } from '@zoryn/utils'
import TreeSelect from './src/tree-select.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZTreeSelect: SFCWithInstall<typeof TreeSelect> =
  withInstall(TreeSelect)

export default ZTreeSelect

export type { TreeSelectInstance } from './src/instance'
